<dx-popup
    #contractDocumentPopup
    width="50%"
    height="60%"
    minWidth="35%"
    minHeight="50%"
    [title]="popupTitle"
    [showTitle]="true"
    [resizeEnabled]="true"
    [showCloseButton]="true"
    [shading]="false"
    [dragEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onShown()"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let data of 'content'" class="contract-document-content">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-data-grid
                        height="100%"
                        allowColumnResizing="true"
                        [showColumnLines]="true"
                        [showRowLines]="true"
                        [hoverStateEnabled]="true"
                        [columnAutoWidth]="true"
                        [showBorders]="true"
                        [dataSource]="contractDocuments"
                    >
                        <dxi-column
                            [visible]="popupTitle !== 'Contract Documents'"
                            [showInColumnChooser]="false"
                            [allowGrouping]="false"
                            [width]="120"
                            alignment="center"
                            cellTemplate="actionCellTemplate"
                        ></dxi-column>
                        <dxi-column
                            dataField="fileName"
                            dataType="string"
                            caption=""
                            [allowGrouping]="false"
                            cellTemplate="fileNameCellTemplate"
                        ></dxi-column>

                        <div *dxTemplate="let row of 'actionCellTemplate'">
                            <dx-button
                                type="default"
                                hint="Attach"
                                text="Attach"
                                [icon]="iconAttach"
                                (onClick)="onAttachClick(row.data)"
                            ></dx-button>
                        </div>
                        <div *dxTemplate="let row of 'fileNameCellTemplate'">
                            <div *ngIf="!!row.value" class="attachment-container">
                                <i class="cc-1-5x" [ngClass]="iconPdf"></i>
                                &nbsp;
                                <app-hyperlink-creator
                                    cssClass="document-name"
                                    [displayText]="row.value"
                                    (onLinkClick)="onDocumentClick(row.data)"
                                ></app-hyperlink-creator>
                            </div>
                        </div>
                    </dx-data-grid>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate class="button-container">
                    <dx-toolbar>
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Close"
                                    hint="Close"
                                    [icon]="iconClose"
                                    (onClick)="onHidden()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel *ngIf="loadingVisible" [position]="{ of: 'body' }" [visible]="loadingVisible"></dx-load-panel>
